<template>
    <div class="table-user">
        <div class="table-user-header">
            <b-row class="pb-3">
                <b-col>
                    Filters for Recommended Removal
                </b-col>
            </b-row>
        </div>
        <div class="scroll-x">
<!--            <table-element-->
<!--                :items="items"-->
<!--                :fields="fields"-->
<!--                @sort="event => sortTable(event)">-->
<!--                <b-btn slot="actions"-->
<!--                       slot-scope="data"-->
<!--                       variant="primary-user"-->
<!--                       :to="{name: 'PaymentItem', params: {itemId: data.item.id}}">Details</b-btn>-->
<!--            </table-element>-->
        </div>
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin} from '@/mixins/tableMixins'

    import TableElement from '~cp/UserPanel/Elements/TableElement'

    export default {
        name: 'RecommendedRemoval',
        // mixins: [tableMixins, paginationMixin, routePaginationMixin],
        components: {
            TableElement
        },
        data() {
            return {
                endpoint: '',
                fields: []
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Reports/InventoryRreport/RecommendedRemoval.vue